import { isEmptyDocument } from 'datocms-structured-text-utils';
import { mapRegionsIntoParameters } from './string.utils';

export const pathToModel = (model = {}, slug = '', regions = []) => {
  const { apiKey } = model;

  if (apiKey === 'work') {
    const regionsAsStrings = mapRegionsIntoParameters([regions]);
    return `/${regionsAsStrings.toLowerCase()}/work/${slug}`;
  } else if (apiKey === 'update') {
    const regionsAsStrings = mapRegionsIntoParameters(regions);
    return `/${regionsAsStrings.toLowerCase()}/update/${slug}`;
  } else if (apiKey === 'resource_publication') {
    const regionsAsStrings = mapRegionsIntoParameters(regions);
    return `/${regionsAsStrings.toLowerCase()}/publications/${slug}`;
  } else if (apiKey === 'take_action') {
    return `/action/${slug}`;
  } else if (apiKey === 'team') {
    return `/team/${slug}`;
  } else if (apiKey === 'archive') {
    const regionsAsStrings = mapRegionsIntoParameters(regions);
    return `/${regionsAsStrings.toLowerCase()}/archive/${slug}`;
  } else if (apiKey === 'resource_video') {
    const regionsAsStrings = mapRegionsIntoParameters(regions);
    return `/${regionsAsStrings.toLowerCase()}/videos/${slug}`;
  } else if (apiKey === 'vacancie') {
    return `/vacancy/${slug}`;
  } else if (apiKey === 'coverage') {
    const regionsAsStrings = mapRegionsIntoParameters(regions);
    return `/${regionsAsStrings.toLowerCase()}/coverage/${slug}`;
  } else if (apiKey === 'press_release') {
    const regionsAsStrings = mapRegionsIntoParameters(regions);
    return `/${regionsAsStrings.toLowerCase()}/press-release/${slug}`;
  } else {
    return `/${slug}`;
  }
};

export const isStructuredContentEmpty = (obj) => {
  if (!obj || (!obj.value && obj.blocks.length === 0)) return true;
  return isEmptyDocument(obj);
};

export const cleanUpLink = (rawText) => {
  if (!rawText) return '';
  return rawText.toLowerCase().replaceAll(' ', '-');
};

export const cleanContent = (content) => {
  let newContent = content;

  if (typeof newContent === 'string') {
    // Eliminar etiquetas [shortcut]
    newContent = newContent.replace(/\[shortcut\](.*?)\[\/shortcut\]/gi, '$1');

    // Eliminar etiquetas [sws_button ...]...[/sws_button]
    newContent = newContent.replace(/\[sws_button[^\]]*\](.*?)\[\/sws_button\]/gi, '$1');

    // Eliminar etiquetas [line]
    newContent = newContent.replace(/\[line\]/gi, '');

    // Eliminar etiquetas [quote width="100%"]...[/quote]
    newContent = newContent.replace(/\[quote[^\]]*\](.*?)\[\/quote\]/gi, '$1');

    // Eliminar etiquetas [quote width="100%"]
    newContent = newContent.replace(/\[quote[^\]]*\]/gi, '');

    // Eliminar etiquetas [/quote]
    newContent = newContent.replace(/\[\/quote\]/gi, '');

    // Eliminar etiquetas [sws_divider_top]
    newContent = newContent.replace(/\[sws_divider_top\]/gi, '');

    // Eliminar etiquetas [et_pb_section admin_label="section"]
    newContent = newContent.replace(/\[et_pb_section[^\]]*\]/gi, '');

    // Eliminar etiquetas [et_pb_row admin_label="row"]
    newContent = newContent.replace(/\[et_pb_row[^\]]*\]/gi, '');

    // Eliminar etiquetas [et_pb_column type="4_4"][et_pb_text admin_label="Text"][/et_pb_text][/et_pb_column]
    newContent = newContent.replace(
      /\[et_pb_column[^\]]*\]\[et_pb_text[^\]]*\](.*?)\[\/et_pb_text\]\[\/et_pb_column\]/gi,
      '$1'
    );

    newContent = newContent.replace(/\[et_pb_column[^\]]*\]/gi, '');
    newContent = newContent.replace(/\[et_pb_text[^\]]*\]/gi, '');

    // Eliminar etiquetas [/et_pb_row]
    newContent = newContent.replace(/\[\/et_pb_row\]/gi, '');

    // Eliminar etiquetas [/et_pb_section]
    newContent = newContent.replace(/\[\/et_pb_section\]/gi, '');

    newContent = newContent.replace(/\[\/et_pb_text\]/gi, '');
    newContent = newContent.replace(/\[\/et_pb_column\]/gi, '');

    return newContent;
  } else if (typeof newContent === 'object' && newContent !== null) {
    for (const key in newContent) {
      newContent[key] = cleanContent(newContent[key]);
    }
  }
  return newContent;
};
